<template>
  <div class="cash-sources-stat">
    <div class="stat-menu-abc">
      <v-container fluid>
        <stat-top-filter
          :last-month="true"
          filial-default="all"
          @applyFilter="fetchData"
        >
          <template v-slot:afterApply="{ filter }">
            <v-btn
              style="border-radius: 10px;"
              height="48px"
              depressed
              color="#D3D5D9"
              :loading="loadingExcel"
              @click="downloadExcel(filter)"
            >
              Выгрузить в Excel
            </v-btn>
          </template>
        </stat-top-filter>

        <loader v-if="loading" />
        <template v-else>
          <div class="stat-menu-abc-table">
            <v-data-table
              v-if="statisticData.length"
              fixed-header
              :headers="headers"
              :items="statisticData"
              :items-per-page="-1"
              class="statistic-datatable headers-nowrap orange-header"
              :footer-props="{disableItemsPerPage: true}"
            >
              <template v-slot:item.filialName="{ item }">
                {{ item.filial ? item.filial.name : '---' }}
              </template>

              <template v-slot:item.ordersCashAmountSum="{ item }">
                {{ item.ordersCashAmountSum | currency }}
              </template>

              <template v-slot:item.ordersTerminalAmountSum="{ item }">
                {{ item.ordersTerminalAmountSum | currency }}
              </template>

              <template v-slot:item.ordersOnlineAmountSum="{ item }">
                {{ item.ordersOnlineAmountSum | currency }}
              </template>

              <template v-slot:item.ordersAgrYaAmountSum="{ item }">
                {{ item.ordersAgrYaAmountSum | currency }}
              </template>

              <template v-slot:item.ordersAgrDcAmount="{ item }">
                {{ item.ordersAgrDcAmount | currency }}
              </template>

              <template v-slot:item.ordersAgrAmount="{ item }">
                {{ item.ordersAgrAmount | currency }}
              </template>

              <template v-slot:item.ordersTotalAmount="{ item }">
                {{ item.ordersTotalAmount | currency }}
              </template>

              <template v-slot:item.snoType="{ item }">
                {{ item.filial ? getSnoTypeName(item.filial.snoType) : '---' }}
              </template>
            </v-data-table>
            <div v-else class="no-data-label">
              Нет записей за выбранный период
            </div>
          </div>
        </template>
      </v-container>
    </div>
  </div>
</template>

<script>
  import StatTopFilter from '@/components/stat/StatTopFilter'
  import Loader from '@/components/loader/Loader'
  import { mapGetters } from 'vuex'
  import SnackbarMessage from '@/mixins/snackbar-message'
  import SnoType from '@/models/enums/SnoType'

  export default {
    name: 'MoneyByPaymentTypes',
    components: { Loader, StatTopFilter },
    mixins: [SnackbarMessage],
    data () {
      return {
        loading: false,
        loadingExcel: false,
        headers: [
          { text: 'Филиал', value: 'filialName', align: 'left' },

          { text: 'Наличные', value: 'ordersCashAmountSum', align: 'center' },
          { text: 'Терминал', value: 'ordersTerminalAmountSum', align: 'center' },
          { text: 'Онлайн', value: 'ordersOnlineAmountSum', align: 'center' },

          // { text: 'Яндекс.Еда', value: 'ordersAgrYaAmountSum', align: 'center' },
          // { text: 'Delivery Club', value: 'ordersAgrDcAmount', align: 'center' },
          { text: 'Агрегаторы', value: 'ordersAgrAmount', align: 'center' },

          { text: 'Итого', value: 'ordersTotalAmount', align: 'center' },

          { text: 'Система налогообложения', value: 'snoType', align: 'left' },
        ],
        statisticData: [],
      }
    },
    computed: {
      ...mapGetters({
        globalFilialId: 'branches/getGlobalFilialId',
      }),
    },
    methods: {
      async fetchData (filter) {
        console.log(filter)
        this.loading = true
        this.statisticData = []

        const payload = {
          from: filter.from,
          to: filter.to,
          filialId: filter.filialId,
          filialPreset: filter.filialPreset,
        }

        try {
          this.statisticData = await this.$store.dispatch('statistic/fetchMoneyByTypeStatistic', payload)
        } catch (err) {
          this.showErrorFromResponse(err)
        }

        this.loading = false
      },

      async downloadExcel (filter) {
        this.loadingExcel = true
        const payload = {
          from: filter.from,
          to: filter.to,
          filialId: filter.filialId,
          filialPreset: filter.filialPreset,
        }

        try {
          await this.$store.dispatch('statistic/downloadMoneyByTypeStatistic', payload)
        } catch (err) {
          this.showErrorFromResponse(err)
        }

        this.loadingExcel = false
      },
      getSnoTypeName (enumValue) {
        return SnoType.getName(enumValue)
      },
    },

  }
</script>

<style lang="less" scoped>
@import "src/assets/styles/statistic.less";
</style>
